import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { mapToVoid } from '@examdojo/core/rxjs';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { EMPTY, take } from 'rxjs';
import { ClassAssignmentService } from './class-assignment.service';

export const classAssignmentSettingsResolver: ResolveFn<void> = () => {
  const classAssignmentService = inject(ClassAssignmentService);
  const errorHandlerService = inject(ErrorHandlerService);

  return classAssignmentService.fetchWeeklyPublishMarksLimit().pipe(
    errorHandlerService.catchHttpErrors(() => EMPTY),
    take(1),
    mapToVoid(),
  );
};
